import React from "react";
import {Checkbox as SemCheckbox, Radio} from "semantic-ui-react";

const errorStyle = {
    marginBottom: 10,
    color: '#dc0000',
    fontSize: '0.7em'
}

const styles = {
    container: {
        width:'100%',
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop:10
    },
    label: {
        float:'left',
        fontSize: '1em'
    },
    radioLabel: {
        fontSize: '0.8em',
        marginTop:5,
        marginLeft:2
    }
}

// Checkbox input
export const Checkbox = ({
                      field: { name, value, onChange, onBlur },
                      form: { errors, touched, setFieldValue },
                      id,
                      label,
                      className,
                      labelStyle,
                      ...props
                  }) => {

    return (
        <div style={{...styles.container, ...props.style}}>
            <span style={{...styles.label, ...labelStyle}}>
                {props.customlabel}
            </span>

            <SemCheckbox toggle
                         name={name}
                         type="checkbox"
                         id={id}
                         checked={value}
                         onChange={onChange}
                         onBlur={onBlur}
                         {...props}
                style={{float:'right', zIndex: 0}}
            />

            {
                touched[name] && errors[name] &&
                <div style={errorStyle}>{errors[name]}</div>
            }
        </div>
    );
};

// Radio input
export const RadioButton = ({
                         field: { name, value, onChange, onBlur },
                         id,
                         label,
                         className,
                         ...props
                     }) => {
    return (
        <div>
            <Radio
                label={props.customlabel}
                name={name}
                   id={id}
                   type="radio"
                   value={id} // could be something else for output?
                   checked={id === value}
                   onChange={onChange}
                   onBlur={onBlur}
                   {...props}
            />
        </div>
    );
};